<template>
  <div class="search-ean center-align">
    <div class="col-s12">
      <label for="ean">Saisir la fin de l'EAN du produit</label>
      <input type="number" id="ean" v-model="ean" @keyup.enter="$emit('search', ean, null)">
    </div>
    <button
      @click="$emit('search', ean, null)"
      class="btn waves-effect waves-light btn-brico m-t"
      v-bind:class="{ disabled: loading }"
    >
      Rechercher
      <i class="material-icons right">send</i>
    </button>
  </div>
</template>

<script>
export default {
  props: ["loading"],
  data() {
    return {
      ean: null
    };
  }
};
</script>

<style>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
  text-align: center;
  height: 35px !important;
  float: left;
  width: 60%;
  padding: 0 !important;
  margin: 0 !important;
  border: 2px solid black !important;
  box-sizing: inherit !important;
}
</style>
